import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { popIn } from '@common/utils/services';
import JournalForm from '../Form';
import {
	fetchJournal,
	updateJournal,
	clearJournal,
} from '@resources/Journal/actions';
import { Title, Modal } from '@common/components';
import { useIntl } from 'react-intl';
import isEmpty from 'lodash.isempty';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';

const Update = (props) => {
	const {
		fetchJournal,
		journal,
		updateJournal,
		visible,
		clearJournal,
		module,
		onCancel,
	} = props;
	const intl = useIntl();

	useEffect(() => {
		const fetchData = async () => {
			await fetchJournal(visible);
		};
		visible ? fetchData() : clearJournal();
	}, [fetchJournal, visible]);

	const handleSubmit = useCallback(
		(data) => {
			return updateJournal(journal._id, data)
				.then((response) => {
					popIn(
						'success',
						intl.formatMessage({
							id: 'message.success.journal.update',
							defaultMessage:
								'An existing Journal entry has been successfully updated',
						})
					);

					onCancel && onCancel();
				})
				.catch((err) => Promise.reject(err));
		},
		[journal]
	);

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.update.journal',
					defaultMessage: 'Update Journal',
				})}
			</Title>
			{!isEmpty(journal) && (
				<JournalForm
					data={journal}
					onSubmit={handleSubmit}
					{...props}
					module={module}
				/>
			)}
		</Modal>
	);
};

const mapStateToProps = ({
	journal,
	event,
	facility,
	ministry,
	mission,
	organization,
	modules,
}) => {
	return {
		journal,
		event,
		facility,
		ministry,
		mission,
		organization,
		modules,
	};
};

export default connect(mapStateToProps, {
	fetchJournal,
	updateJournal,
	fetchModulesBySubmoduleCode,
	clearJournal,
})(Update);
